/**
 * Frecency from EVERY surface, not only the palette (PLAN §3.4): an item
 * opened from a sidebar, a deep link or a tab strip counts too, so "people I
 * chatted with" rank high even if never opened from the palette.
 *
 * Instead of a call in each open function, this watches where those
 * functions land — the active document / board / request tab and the active
 * chat conversation — and records a visit when it changes. One subscriber,
 * no edits inside the stores.
 */
import { recordVisit } from './frecency';
import { refOf } from './types';
import { useTabsStore } from '../store/tabsStore';
import { useChatStore } from '../store/chatStore';
import { dmOther } from '../components/chatHelpers';

/** What a store state points at, as palette refs. Pure (tested). */
export function activeRefs(tabs, chat) {
  const out = {};
  const doc = (tabs.documentTabs || []).find((t) => t.id === tabs.activeDocumentTabId);
  if (doc?.documentId) out.document = refOf('documents', doc.documentId);
  const board = (tabs.taskManagerTabs || []).find((t) => t.id === tabs.activeTaskManagerTabId);
  if (board?.boardId) out.board = refOf('boards', board.boardId);
  const req = (tabs.requestTabs || []).find((t) => t.id === tabs.activeRequestTabId);
  if (req?.originalId != null) out.request = refOf('requests', req.originalId);
  if (chat && chat.activeChannelId != null) {
    const ch = (chat.channels || []).find((c) => String(c.id) === String(chat.activeChannelId));
    if (ch?.kind === 'dm') {
      const other = dmOther(ch, chat.currentUserId);
      if (other) out.chat = refOf('people', other.user_id);
    } else if (ch) out.chat = refOf('chats', ch.id);
  }
  return out;
}

let stop = null;

export function startFrecencyFeeds(record = recordVisit) {
  if (stop) return stop;
  let last = activeRefs(useTabsStore.getState(), useChatStore.getState());
  const check = () => {
    const next = activeRefs(useTabsStore.getState(), useChatStore.getState());
    for (const k of ['document', 'board', 'request', 'chat']) {
      if (next[k] && next[k] !== last[k]) record(next[k]);
    }
    last = next;
  };
  const a = useTabsStore.subscribe(check);
  const b = useChatStore.subscribe((s, prev) => {
    if (s.activeChannelId !== prev?.activeChannelId || s.channels !== prev?.channels) check();
  });
  stop = () => {
    a();
    b();
    stop = null;
  };
  return stop;
}
